import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { managersMe } from "@/lib/afmApi";
import { Loading } from "@/components/common";

// Inicio de la app instalada: subcuentas (manager, equipo o artista) van a su sello; el resto, a su panel.
export default function AppStart() {
  const [to, setTo] = useState(null);
  useEffect(() => {
    managersMe().then((d) => setTo(d?.manager ? "/mi-sello" : "/dashboard")).catch(() => setTo("/dashboard"));
  }, []);
  return to ? <Navigate to={to} replace /> : <Loading />;
}
